import OrderSortFilter from "../symbols/orderSortFilter";

const setOrderSortFilterAction = (data) => ({
  type: OrderSortFilter.SET_ORDER_SORT_FILTER,
  payload: data
});
const clearOrderSortFilterAction = () => ({
  type: OrderSortFilter.CLEAR_ORDER_SORT_FILTER,
});
export function setOrderSortFilter(data) {
  return (dispatch: any) => dispatch(setOrderSortFilterAction(data));
}

export function clearAccountDetails() {
  return (dispatch: any) => {
    dispatch(clearOrderSortFilterAction());
  };
}
